import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import MainBanner from "../../../components/MainBanner";
import LatestNews from "../../../components/LatestNews";
import ConsultantCarousel from "../../../components/ConsultantCarousel";
import SolutionsAccordion from "../../../components/SolutionsAccordion";
import VideoWithText from "../../../components/VideoWithText";
import FAQ from "../../../components/FAQ";
import LatestSuccessStory from "../../../components/LatestSuccessStory";
import ImageWithTextWithOverlay from "components/ImageWithTextWithOverlay";

export default function SynergyScientificSolutionsPage({
  global,
  all_news,
  all_case_studies,
  all_services,
  all_consultants,
  synergyfilter,
  faqFilter,
}) {
  return (
    <>
      <SeoHead
        page_name={`Synergy Scientific Solutions | Project engineering and technical recruitment specialists | Carbon60`}
        canonical_link={`synergy-scientific-solutions`}
      />
      <MainBanner
        global={global}
        pathPrefix={`synergy_scientific_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Synergy Scientific Solutions</h1>
          </>
        }
        bots={<ld-slot name="Synergy Scientific Solutions"></ld-slot>}
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        buttonTitle={"Get In Touch"}
        editableContent={true}
        displayImage1={false}
        popUpModal_1={true}
        popUpModal_1_form_id={"6c9ee93b-e8d3-43f8-b497-83ed2206fdc7"}
        dialog_content_1={"Contact Us"}
        successPageUrl={"/submission-success/"}
      />

      <VideoWithText
        global={global}
        pathname={`synergy-scientific-solutions`}
        pathPrefix={`synergy_scientific_page.all_solutions`}
        customClass={`pt-5`}
        post={synergyfilter}
        buttonTitle={`Learn More`}
        containerWidth={true}
      />

      <SolutionsAccordion
        global={global}
        pathPrefix={`synergy_scientific_page.solutions_accordion`}
        customClass={`py-5 bg-light`}
        content={
          <>
            <h2>
              Empowering Your Business and People with Synergy Scientific
              Services
            </h2>
          </>
        }
        post={all_services}
      />
      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`synergy_scientific_page.image_with_text_with_overlay`}
        customClass={`py-5 `}
        backgroundColor={"#ffffff"}
        content={
          <>
            <h2>Lab Leaders Vision 2025 </h2>
            <p>
              Discover strategies for success with insights from over 1,000
              surveyed lab leaders, plus expert guidance and advice. Explore
              workforce challenges, automation and efficiency strategies to
              drive lab innovation and resilience.
            </p>
          </>
        }
        buttonTitle={`Download Now`}
        buttonLink={`/blog/lab-leader-vision-2025`}
        imageURL={`/site-assets/images/Synergy_Lab_Leaders.png`}
        imageALT={`Job Seekers Featured Image`}
        popUpModal_1={false}
      />
      <LatestSuccessStory
        global={global}
        pathPrefix={`homepage.latest_case_studies`}
        customClass={`pt-5 pb-5`}
        content={
          <>
            <h2>Customer Success Stories</h2>
          </>
        }
        post={all_case_studies}
        swiperID={`LatestCaseStudiesSwiper`}
      />

      <FAQ
        global={global}
        pathname={`synergy-scientific-solutions`}
        pathPrefix={`synergy_scientific_page.all_solutions`}
        post={faqFilter}
        buttonTitle={`Learn More`}
      />

      {/* <AllConsultants
        global={global}
        pathPrefix={`meet_the_team_page.all_consultants`}
        customClass={`py-5`}
        content={
          <>
            <h2>Our Team</h2>
          </>
        }
        post={all_consultants}
      /> */}

      <ConsultantCarousel
        global={global}
        pathPrefix={`meet_the_team_page.all_consultants`}
        customClass={`py-5 grayGradientBg`}
        post={all_consultants}
        content={
          <>
            <h2>Our Team</h2>
          </>
        }
        swiperID={`ConsultantsSwiper`}
      />

      <LatestNews
        global={global}
        pathPrefix={`homepage.latest_news`}
        customClass={`py-5 bg-latest-news`}
        post={all_news}
        content={
          <>
            <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
            <p>
              Our tech expertise and partner-led approach allows us to deliver
              highly successful results for our clients so they can attract and
              retain unique talent for their business. Explore our latest
              collection of case studies, news, events, and insights
            </p>
          </>
        }
        buttonLink={`/blog/`}
        buttonTitle={`View All Insights`}
        swiperID={`LatestNewsSwiper`}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  const solutions = await Collection("synergy_scientific_solutions");
  const all_solutions = solutions.orderBy("order").getItems();

  const synergyfilter = all_solutions.filter(function (post) {
    return post.id === "0d0aa89b-fabc-4fa2-8bf1-cfc0275fedf4";
  });

  const faqFilter = all_solutions.filter(function (post) {
    return post.id === "101793ce-cb38-4d58-b3a4-de80aae8e33d";
  });

  const services = await Collection("synergy_scientific_services");
  const all_services = services.orderBy("order").getItems();

  const news = (await Collection("news"))
    .filter((matchingNews) =>
      matchingNews.page_tag?.en?.includes("Synergy Scientific Solutions")
    )
    .filter((matchingNews) => !matchingNews.tag?.en?.includes("Case Study"))
    .filter(function (post) {
      return post.country?.en == "United Kingdom" || post.country?.en == "All";
    });
  const all_news = news.orderBy("order").getItems().slice(0, 8);

  const case_studies = (await Collection("news"))
    .filter((matchingItems) =>
      matchingItems.page_tag?.en?.includes("Synergy Scientific Solutions")
    )
    .filter((matchingItems) => matchingItems.tag?.en?.includes("Case Study"))
    .filter(function (post) {
      return post.country?.en == "United Kingdom" || post.country?.en == "All";
    });
  const all_case_studies = case_studies.orderBy("order").getItems().slice(0, 8);

  const consultants = (await Collection("consultants"))
    .filter(function (post) {
      return post.country?.en == "UK";
    })
    .filter(function (post) {
      return post.synergy_scientific_solutions_page?.en;
    });
  const all_consultants = consultants.orderBy("_order").getItems();

  return {
    props: {
      global,
      all_news,
      all_case_studies,
      faqFilter,
      all_services,
      all_consultants,
      synergyfilter,
    },
  };
}
